import { NavLink } from "react-router-dom";

function Logo(props: any) {
  const { data } = props;

  return (
    <section className="logo-container">
      {data.map((item: any, i: any) => (
        <div key={i}>
          <NavLink to={item.link}>
            <img src={item.image} alt={item.alt} className="logo" />
          </NavLink>
        </div>
      ))}
    </section>
  );
}

export default Logo;
